import axios from '@/axios';

const getScheduleByDate = (channelId, date) => axios.get(`/schedule/v1/channels/${channelId}/schedules/${date}`);
const getScheduleItemsByDate = (channelId, date) => axios.get(`/schedule/v1/channels/${channelId}/schedules/${date}/items`);
const shiftProgram = (channelId, programId, date, payload) => axios.post(
  `/schedule/v1/channels/${channelId}/schedules/${date}/adjustments?fromScheduleItemId=${programId}`,
  payload,
);
const getAvailableScheduleByMonth = (channelId, month) => axios.get(`/schedule/v1/channels/${channelId}/monthly-schedules/${month}`);
const updateScheduleItem = (scheduleId, payload) => axios.put(`schedule/v1/schedule-items/${scheduleId}/adjustment`, payload);

export {
  getScheduleByDate,
  getScheduleItemsByDate,
  getAvailableScheduleByMonth,
  shiftProgram,
  updateScheduleItem,
};
